import React, { useState } from "react";

import { ImgWrapper } from "./styled";
const Rocket = () => {
  const [clicked, setClicked] = useState(false);

  const handleClick = () => {
    setClicked(true);
  };
  return <ImgWrapper onClick={handleClick} clicked={clicked}></ImgWrapper>;
};

export default Rocket;
